import { Button, ThemeProvider } from "@material-ui/core";
import { groopTheme } from "../styles/MaterialGroopTheme";
import React, { useEffect } from "react";

interface FollowUpRequestDataEditorProps {
  baseName: string;
  description: string;
  requested: boolean;
  required: boolean;
  disabled: boolean;
}

export const FollowUpRequestDataEditor = (
  props: FollowUpRequestDataEditorProps,
): JSX.Element => {
  const { baseName, description, required, requested, disabled } = { ...props };
  const [isRequested, setIsRequested] = React.useState<boolean>(
    required || requested,
  );

  useEffect(() => {
    setIsRequested(required || requested);
  }, [requested, required]);

  /* Required is a special case for follow-ups. The request itself is a boolean
     so if it's required then we just check it by default and don't display it
     since the user doesn't really have any options. */
  return (
    <ThemeProvider theme={groopTheme}>
      <div className={`flex space-x-3 post-component ${required && "hidden"}`}>
        <img
          className="groopit-component-icon-sm"
          src="/Content/Images/ic_notresponded.png"
        />
        <div className="flex-grow">
          <div className="text-display-normal text-color-secondary">
            Follow-up (tap to activate)
          </div>
          <div className="flex items-center gap-2">
            <Button
              variant={isRequested ? "contained" : "outlined"}
              color="primary"
              onClick={() => setIsRequested(!isRequested)}
              disabled={disabled}
            >
              {description}
            </Button>
          </div>
          <input
            type="hidden"
            name={`${baseName}.FollowUpRequested`}
            value={isRequested ? "true" : "false"}
          />
        </div>
      </div>
    </ThemeProvider>
  );
};
